import { Stack } from '@nautilusbio/nb-design-system/Stack';
import React, { type ReactNode, memo } from 'react';
import { useTranslation } from 'react-i18next';

import styles from '../../../styles.module.css';
import type { InstrumentRunPublic } from '../../../types';
import TextRow from '../../TextRow';
import ValueRow from '../../ValueRow';

export type RowType = {
  label: string;
  value: ReactNode;
};
export type RunMetaPopoverProps = {
  formatDate: (value: Date | string | number | null | undefined) => string;
  run: InstrumentRunPublic;
};

const RunMetaPopover = ({ formatDate, run }: RunMetaPopoverProps) => {
  const { t } = useTranslation('runs', { keyPrefix: 'header' });
  const rows: RowType[] = [];

  if (run.created_at) {
    rows.push({
      label: t('created'),
      value: <ValueRow label={formatDate(run.created_at)} value={run.created_by_full_name} />,
    });
  }

  if (run.updated_at && run.updated_by_full_name) {
    rows.push({
      label: t('updated'),
      value: <ValueRow label={formatDate(run.updated_at)} value={run.updated_by_full_name} />,
    });
  }

  if (run.submitted_at && run.submitted_by_full_name) {
    rows.push({
      label: t('submitted'),
      value: <ValueRow label={formatDate(run.submitted_at)} value={run.submitted_by_full_name} />,
    });
  }

  if (run.completed_at) {
    rows.push({
      label: t('completed'),
      value: <ValueRow label={formatDate(run.completed_at)} />,
    });
  }

  return (
    <Stack className={styles.noWrap} fullWidth gap={4} orientation="vertical">
      {rows.map(r => (
        <TextRow key={r.label} label={r.label} value={r.value} />
      ))}
    </Stack>
  );
};

export default memo(RunMetaPopover);
